export const BILLER_STATE_CLEARED = 'biller.STATE_CLEARED';
export const GET_BILLER_MY_ADMIN_INFO_REQUEST = 'biller.GET_BILLER_MY_ADMIN_INFO_REQUEST';
export const GET_BILLER_MY_ADMIN_INFO_SUCCESS = 'biller.GET_BILLER_MY_ADMIN_INFO_SUCCESS';
export const GET_BILLER_MY_ADMIN_INFO_FAIL = 'biller.GET_BILLER_MY_ADMIN_INFO_FAIL';
export const GET_BILLER_COMPANY_INFO_REQUEST = 'biller.GET_BILLER_COMPANY_INFO_REQUEST';
export const GET_BILLER_COMPANY_INFO_SUCCESS = 'biller.GET_BILLER_COMPANY_INFO_SUCCESS';
export const GET_BILLER_COMPANY_INFO_FAIL = 'biller.GET_BILLER_COMPANY_INFO_FAIL';
export const UPLOAD_BILLER_COMPANY_LOGO_REQUEST = 'biller.UPLOAD_BILLER_COMPANY_LOGO_REQUEST';
export const UPLOAD_BILLER_COMPANY_LOGO_SUCCESS = 'biller.UPLOAD_BILLER_COMPANY_LOGO_SUCCESS';
export const UPLOAD_BILLER_COMPANY_LOGO_FAIL = 'biller.UPLOAD_BILLER_COMPANY_LOGO_FAIL';
export const UPDATE_BILLER_COMPANY_INFO_REQUEST = 'biller.UPDATE_BILLER_COMPANY_INFO_REQUEST';
export const UPDATE_BILLER_COMPANY_INFO_SUCCESS = 'biller.UPDATE_BILLER_COMPANY_INFO_SUCCESS';
export const UPDATE_BILLER_COMPANY_INFO_FAIL = 'biller.UPDATE_BILLER_COMPANY_INFO_FAIL';
export const UNBLOCK_BILLER_USER_REQUEST = 'biller.UNBLOCK_BILLER_USER_REQUEST';
export const UNBLOCK_BILLER_USER_SUCCESS = 'biller.UNBLOCK_BILLER_USER_SUCCESS';
export const UNBLOCK_BILLER_USER_FAIL = 'biller.UNBLOCK_BILLER_USER_FAIL';
export const UPLOAD_BILLER_OTHER_BANK_LOGO_REQUEST = 'biller.UPLOAD_BILLER_OTHER_BANK_LOGO_REQUEST';
export const UPLOAD_BILLER_OTHER_BANK_LOGO_SUCCESS = 'biller.UPLOAD_BILLER_OTHER_BANK_LOGO_SUCCESS';
export const UPLOAD_BILLER_OTHER_BANK_LOGO_FAIL = 'biller.UPLOAD_BILLER_OTHER_BANK_LOGO_FAIL';
// PROFILES
export const GET_BILLER_PROFILE_LIST_REQUEST = 'biller.GET_BILLER_PROFILE_LIST_REQUEST';
export const GET_BILLER_PROFILE_LIST_SUCCESS = 'biller.GET_BILLER_PROFILE_LIST_SUCCESS';
export const GET_BILLER_PROFILE_LIST_FAIL = 'biller.GET_BILLER_PROFILE_LIST_FAIL';
export const CURRENT_BILLER_PROFILE_SELECTED = 'biller.CURRENT_BILLER_PROFILE_SELECTED';
export const UPLOAD_BILLER_PROFILE_LOGO_REQUEST = 'biller.UPLOAD_BILLER_PROFILE_LOGO_REQUEST';
export const UPLOAD_BILLER_PROFILE_LOGO_SUCCESS = 'biller.UPLOAD_BILLER_PROFILE_LOGO_SUCCESS';
export const UPLOAD_BILLER_PROFILE_LOGO_FAIL = 'biller.UPLOAD_BILLER_PROFILE_LOGO_FAIL';
export const UPDATE_BILLER_PROFILE_INFO_REQUEST = 'biller.UPDATE_BILLER_PROFILE_INFO_REQUEST';
export const UPDATE_BILLER_PROFILE_INFO_SUCCESS = 'biller.UPDATE_BILLER_PROFILE_INFO_SUCCESS';
export const UPDATE_BILLER_PROFILE_INFO_FAIL = 'biller.UPDATE_BILLER_PROFILE_INFO_FAIL';
export const DELETE_BILLER_PROFILE_INFO_REQUEST = 'biller.DELETE_BILLER_PROFILE_INFO_REQUEST';
export const DELETE_BILLER_PROFILE_INFO_SUCCESS = 'biller.DELETE_BILLER_PROFILE_INFO_SUCCESS';
export const DELETE_BILLER_PROFILE_INFO_FAIL = 'biller.DELETE_BILLER_PROFILE_INFO_FAIL';
// SLIPS
export const GET_BILLER_SLIP_LIST_REQUEST = 'biller.GET_BILLER_SLIP_LIST_REQUEST';
export const GET_BILLER_SLIP_LIST_SUCCESS = 'biller.GET_BILLER_SLIP_LIST_SUCCESS';
export const GET_BILLER_SLIP_LIST_FAIL = 'biller.GET_BILLER_SLIP_LIST_FAIL';
export const CURRENT_BILLER_SLIP_SELECTED = 'biller.CURRENT_BILLER_SLIP_SELECTED';
export const CREATE_BILLER_SLIP_INFO_REQUEST = 'biller.CREATE_BILLER_SLIP_INFO_REQUEST';
export const CREATE_BILLER_SLIP_INFO_SUCCESS = 'biller.CREATE_BILLER_SLIP_INFO_SUCCESS';
export const CREATE_BILLER_SLIP_INFO_FAIL = 'biller.CREATE_BILLER_SLIP_INFO_FAIL';
export const UPDATE_BILLER_SLIP_INFO_REQUEST = 'biller.UPDATE_BILLER_SLIP_INFO_REQUEST';
export const UPDATE_BILLER_SLIP_INFO_SUCCESS = 'biller.UPDATE_BILLER_SLIP_INFO_SUCCESS';
export const UPDATE_BILLER_SLIP_INFO_FAIL = 'biller.UPDATE_BILLER_SLIP_INFO_FAIL';
export const DELETE_BILLER_SLIP_INFO_REQUEST = 'biller.DELETE_BILLER_SLIP_INFO_REQUEST';
export const DELETE_BILLER_SLIP_INFO_SUCCESS = 'biller.DELETE_BILLER_SLIP_INFO_SUCCESS';
export const DELETE_BILLER_SLIP_INFO_FAIL = 'biller.DELETE_BILLER_SLIP_INFO_FAIL';
// COMPANY ADMIN USERS
export const GET_BILLER_USER_LIST_REQUEST = 'biller.GET_BILLER_USER_LIST_REQUEST';
export const GET_BILLER_USER_LIST_SUCCESS = 'biller.GET_BILLER_USER_LIST_SUCCESS';
export const GET_BILLER_USER_LIST_FAIL = 'biller.GET_BILLER_USER_LIST_FAIL';
export const CURRENT_BILLER_USER_SELECTED = 'biller.CURRENT_BILLER_USER_SELECTED';
export const CREATE_BILLER_USER_INFO_REQUEST = 'biller.CREATE_BILLER_USER_INFO_REQUEST';
export const CREATE_BILLER_USER_INFO_SUCCESS = 'biller.CREATE_BILLER_USER_INFO_SUCCESS';
export const CREATE_BILLER_USER_INFO_FAIL = 'biller.CREATE_BILLER_USER_INFO_FAIL';
export const UPDATE_BILLER_USER_INFO_REQUEST = 'biller.UPDATE_BILLER_USER_INFO_REQUEST';
export const UPDATE_BILLER_USER_INFO_SUCCESS = 'biller.UPDATE_BILLER_USER_INFO_SUCCESS';
export const UPDATE_BILLER_USER_INFO_FAIL = 'biller.UPDATE_BILLER_USER_INFO_FAIL';
export const DELETE_BILLER_USER_INFO_REQUEST = 'biller.DELETE_BILLER_USER_INFO_REQUEST';
export const DELETE_BILLER_USER_INFO_SUCCESS = 'biller.DELETE_BILLER_USER_INFO_SUCCESS';
export const DELETE_BILLER_USER_INFO_FAIL = 'biller.DELETE_BILLER_USER_INFO_FAIL';
// Payer
export const PRINT_PAYER_SLIPS_REQUEST = 'biller.PRINT_PAYER_SLIP_REQUEST';
export const PRINT_PAYER_SLIPS_SUCCESS = 'biller.PRINT_PAYER_SLIP_SUCCESS';
export const PRINT_PAYER_SLIPS_FAIL = 'biller.PRINT_PAYER_SLIP_FAIL';
export const EMAIL_PAYER_SLIPS_REQUEST = 'biller.EMAIL_PAYER_SLIP_REQUEST';
export const EMAIL_PAYER_SLIPS_SUCCESS = 'biller.EMAIL_PAYER_SLIP_SUCCESS';
export const EMAIL_PAYER_SLIPS_FAIL = 'biller.EMAIL_PAYER_SLIP_FAIL';
export const PRINT_PAYER_QR_REQUEST = 'biller.PRINT_PAYER_QR_REQUEST';
export const PRINT_PAYER_QR_SUCCESS = 'biller.PRINT_PAYER_QR_SUCCESS';
export const PRINT_PAYER_QR_FAIL = 'biller.PRINT_PAYER_QR_FAIL';
export const EMAIL_PAYER_QR_REQUEST = 'biller.EMAIL_PAYER_QR_REQUEST';
export const EMAIL_PAYER_QR_SUCCESS = 'biller.EMAIL_PAYER_QR_SUCCESS';
export const EMAIL_PAYER_QR_FAIL = 'biller.EMAIL_PAYER_QR_FAIL';
export const DELETE_PAYER_SLIPS_REQUEST = 'biller.DELETE_PAYER_SLIP_REQUEST';
export const DELETE_PAYER_SLIPS_SUCCESS = 'biller.DELETE_PAYER_SLIP_SUCCESS';
export const DELETE_PAYER_SLIPS_FAIL = 'biller.DELETE_PAYER_SLIP_FAIL';
export const IMPORT_BILLER_SLIPS_REQUEST = 'biller.IMPORT_BILLER_SLIPS_REQUEST';
export const IMPORT_BILLER_SLIPS_SUCCESS = 'biller.IMPORT_BILLER_SLIPS_SUCCESS';
export const IMPORT_BILLER_SLIPS_FAIL = 'biller.IMPORT_BILLER_SLIPS_FAIL';
export const TOGGLE_BILLER_SLIP_SEARCH_OPTION = 'biller.TOGGLE_BILLER_SLIP_SEARCH_OPTION';



// WEBPACK FOOTER //
// ./src/store/mutations/biller.js